import { PARAM_PAGE } from '../constants';
import {createActionCreator} from 'PyzShopUi/scripts/shop-ui/includes/enhanced-reducer';

export interface SetPaginationPayload {
    [PARAM_PAGE]: string;
}

const SET_PAGINATION = 'SET_PAGINATION';

export const setPagination = createActionCreator<SetPaginationPayload>(SET_PAGINATION);
